module.exports = __webpack_public_path__ + "media/images/flags/1x1/isl-fb527fd2c7de9f38946f97817413827d.svg";